import React from 'react';

const AndroidIcon = () => (
  <svg id="smd-google-play-badge" viewBox="0 0 150 47" width="150" height="47">
    <g fill="none" fillRule="evenodd">
      <rect width="150" height="47" fill="#000" rx="6" />
      <text
        fill="#C2C5CC"
        fontFamily="Backpack-Regular, Backpack"
        fontSize="11"
      >
        <tspan x="41" y="16">
          Доступно в
        </tspan>
      </text>
      <g fillRule="nonzero">
        <path
          fill="url(#google-play-a)"
          d="M.495.56a2.08 2.08 0 00-.477 1.455v22.97a2.077 2.077 0 00.477 1.454l.073.073 12.867-12.856v-.301L.568.488.495.561z"
          transform="translate(10 10)"
        />
        <path
          fill="url(#google-play-b)"
          d="M17.692 17.945l-4.257-4.29v-.3l4.257-4.3.094.052 5.099 2.898c1.453.82 1.453 2.17 0 3l-5.078 2.888-.115.052z"
          transform="translate(10 10)"
        />
        <path
          fill="url(#google-play-c)"
          d="M17.817 17.882L13.435 13.5.495 26.44a1.693 1.693 0 002.16.062l15.172-8.62"
          transform="translate(10 10)"
        />
        <path
          fill="url(#google-play-d)"
          d="M17.817 9.118L2.645.498a1.693 1.693 0 00-2.16.063L13.435 13.5l4.382-4.382z"
          transform="translate(10 10)"
        />
      </g>
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M73.42 26.44a5.053 5.053 0 105.077 5.053 4.982 4.982 0 00-5.077-5.053zm0 8.12a3.068 3.068 0 112.853-3.067 2.925 2.925 0 01-2.853 3.068zm-11.07-8.12a5.053 5.053 0 105.066 5.053 4.982 4.982 0 00-5.077-5.053h.012zm0 8.12a3.068 3.068 0 112.842-3.067 2.925 2.925 0 01-2.853 3.068h.012zm-13.185-6.562v2.14H54.3a4.482 4.482 0 01-1.189 2.699 5.255 5.255 0 01-3.96 1.57 5.707 5.707 0 110-11.415 5.47 5.47 0 013.889 1.534l1.51-1.51a7.479 7.479 0 00-5.386-2.224 7.86 7.86 0 100 15.707 7.134 7.134 0 005.48-2.2 7.134 7.134 0 001.856-5.017 6.98 6.98 0 00-.12-1.344l-7.216.06zm53.872 1.664a4.756 4.756 0 00-4.328-3.222 4.756 4.756 0 00-4.756 5.053 4.946 4.946 0 005.018 5.053 5.03 5.03 0 004.209-2.235l-1.724-1.189a2.89 2.89 0 01-2.485 1.403 2.568 2.568 0 01-2.45-1.534l6.766-2.794-.25-.535zm-6.896 1.689a2.77 2.77 0 012.64-2.95 1.962 1.962 0 011.878 1.07l-4.518 1.88zm-5.493 4.898h2.224V21.387h-2.224v14.862zm-3.638-8.68h-.083a3.567 3.567 0 00-2.664-1.188 5.065 5.065 0 000 10.118 3.448 3.448 0 002.664-1.19h.071v.726c0 1.938-1.034 2.973-2.699 2.973a2.794 2.794 0 01-2.544-1.796l-1.938.809a4.815 4.815 0 004.482 2.984c2.604 0 4.756-1.534 4.756-5.267v-9H87.01v.832zm-2.545 6.992a3.08 3.08 0 010-6.135 2.854 2.854 0 012.7 3.067 2.83 2.83 0 01-2.711 3.068h.011zm28.988-13.174h-5.315v14.862h2.223v-5.636h3.104a4.625 4.625 0 100-9.226h-.012zm0 7.134h-3.104v-5.065h3.151a2.55 2.55 0 010 5.1l-.047-.035zm13.709-2.14a4.161 4.161 0 00-3.96 2.27l1.974.82a2.104 2.104 0 012.021-1.093 2.14 2.14 0 012.378 1.914v.155a4.91 4.91 0 00-2.318-.57c-2.129 0-4.28 1.188-4.28 3.34a3.436 3.436 0 003.685 3.27 3.127 3.127 0 002.854-1.427h.071v1.19h2.14v-5.72c0-2.604-1.973-4.114-4.506-4.114l-.06-.035zm-.274 8.144c-.725 0-1.736-.368-1.736-1.26 0-1.19 1.26-1.582 2.378-1.582a3.947 3.947 0 012.021.5 2.687 2.687 0 01-2.603 2.378l-.06-.036zm12.639-7.788l-2.544 6.445h-.072l-2.64-6.445h-2.377l3.959 9.013-2.26 5.005h2.32L142 26.737h-2.473zM119.54 36.25h2.224V21.387h-2.224v14.862z"
      />
    </g>
  </svg>
);

export default AndroidIcon;
